import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'

/**
 * ORDER NOW reorder candidates scoped to the PO's recipient (Session 7.5).
 * Powers the "Prefill from dashboard" card in the Create PO wizard's Setup
 * step. Pass `supplier` for a multi-vendor PO (backend resolves to the
 * supplier's carried vendor brands), or `vendor` for a single-vendor PO.
 */
export interface PrefillScope {
  supplier?: string | null
  vendor?: string | null
}

export function usePrefillProducts(scope: PrefillScope) {
  const supplier = (scope.supplier ?? '').trim() || null
  const vendor = (scope.vendor ?? '').trim() || null
  return useQuery({
    queryKey: ['products', { supplier, vendor, needs_reorder: true }] as const,
    queryFn: async () => {
      const params: { supplier?: string; vendor?: string; needs_reorder: boolean } = {
        needs_reorder: true,
      }
      if (supplier) params.supplier = supplier
      else if (vendor) params.vendor = vendor
      const { data, error } = await apiClient.GET('/api/inventory/products', {
        params: { query: params },
      })
      if (error) throw new Error('Failed to load prefill candidates')
      return data ?? []
    },
    enabled: !!supplier || !!vendor,
    staleTime: 30_000,
  })
}
